/*
 * <gallery-dots> — minimal slide indicator for the product media slider on mobile.
 * Renders one dot per slide, marks the active one on scroll, and scrolls to a
 * slide when its dot is tapped. Each slide is a full-viewport-width slide, so
 * the active index is simply scrollLeft / slideWidth.
 */
class GalleryDots extends HTMLElement {
  connectedCallback() {
    this.slider = this.closest('slider-component')?.querySelector('.product__media-list');
    if (!this.slider) return;

    this.slides = Array.from(this.slider.querySelectorAll('.product__media-item'));
    if (this.slides.length <= 1) {
      this.hidden = true;
      return;
    }

    this.dots = this.slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gallery-dots__dot';
      dot.setAttribute('aria-label', `${index + 1}`);
      dot.addEventListener('click', () => {
        this.slider.scrollTo({ left: index * this.slider.clientWidth, behavior: 'smooth' });
      });
      this.appendChild(dot);
      return dot;
    });

    this._onScroll = this._onScroll.bind(this);
    this.slider.addEventListener('scroll', this._onScroll, { passive: true });
    this._update();
  }

  disconnectedCallback() {
    if (this.slider && this._onScroll) {
      this.slider.removeEventListener('scroll', this._onScroll);
    }
  }

  _onScroll() {
    cancelAnimationFrame(this._raf);
    this._raf = requestAnimationFrame(() => this._update());
  }

  _update() {
    const width = this.slider.clientWidth || 1;
    const index = Math.round(this.slider.scrollLeft / width);
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }
}

if (!customElements.get('gallery-dots')) {
  customElements.define('gallery-dots', GalleryDots);
}
